import $ from 'jquery';

export default {
  init() {
    // JavaScript to be fired on all pages
    this.teamToggle();

    //Initalise all slick sliders
    var sliders = $('.slick-slider');
    sliders.each(function() {
      $(this).slick();
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
  teamToggle() {
    $('section.team .toggl').on('click', (e) => {
      if (!$(e.currentTarget).hasClass('open')) {
        $('section.team .toggl').removeClass('open')
        $('.member__description').slideUp(500);
        $(e.currentTarget).addClass('open')
        $(e.currentTarget).siblings('.member__description').slideDown(1000);
      } else {
        $(e.currentTarget).removeClass('open');
        $(e.currentTarget).siblings('.member__description').slideUp(500);
      }

      e.preventDefault();
    });
  },
};



// WEBPACK FOOTER //
// /home/pentarchcom/public_html/website/web/app/themes/main-theme/resources/assets/scripts/routes/common.js